module.exports = __webpack_public_path__ + "img/mobile_map_chile_hospicio.f41ecf47.svg";